// @flow

import * as React from "react"
import type {BabyAnswer} from "../../types"
import {withTranslation} from "react-i18next"

type Props = {
  question: BabyAnswer,
  isSaving: boolean,
  t: any,
  onQuestionUpdate: (
    SyntheticInputEvent<HTMLInputElement | HTMLSelectElement>,
    BabyAnswer
  ) => void,
}

class IntakeSurveyQuestionInput extends React.Component<Props> {
  renderRemarks() {
    const {t, question, onQuestionUpdate, isSaving} = this.props
    return (
      <div className="form-group mt-3">
        <label htmlFor={`sq-${question.babyQuestionId}`}>
          {t("survey.question.remarks")}
        </label>
        <textarea
          id={`sq-${question.babyQuestionId}`}
          className="form-control"
          name="remarks"
          value={question.remarks}
          disabled={isSaving == true}
          onChange={(e) => onQuestionUpdate(e, question)}
        />
      </div>
    )
  }

  renderMainInput() {
    const {t, question, onQuestionUpdate, isSaving} = this.props
    switch (question.type) {
      case "boolean":
        return (
          <div className="custom-control custom-checkbox custom-control-inline">
            <input
              type="checkbox"
              id={`sq-${question.babyQuestionId}`}
              value={true}
              name="answer"
              onChange={(e) => onQuestionUpdate(e, question)}
              required={true}
              disabled={isSaving == true}
              checked={question.answer === "true"}
              className="custom-control-input"
            />
            <label
              htmlFor={`sq-${question.babyQuestionId}`}
              className="custom-control-label"
            >
              {question.answer == "true"
                ? t("survey.question.generic.yes")
                : t("survey.question.generic.no")}
            </label>
          </div>
        )

      case "list":
        return (
          <select
            className="form-control"
            value={question.answer}
            name="answer"
            disabled={isSaving == true}
            onChange={(e) => onQuestionUpdate(e, question)}
          >
            {question.options.map((o, idx) => (
              <option
                key={`qo-${question.babyQuestionId}-${idx}`}
                value={o.key}
              >
                {o.value}
              </option>
            ))}
          </select>
        )
      case "free_text":
        return (
          <div className="form-group">
            <textarea
              className="form-control"
              name="answer"
              rows="5"
              disabled={isSaving == true}
              value={question.answer || ""}
              onChange={(e) => onQuestionUpdate(e, question)}
            />
          </div>
        )
      case "free":
      default:
        return (
          <div className="form-group">
            <input
              className="form-control"
              type="text"
              name="answer"
              disabled={isSaving == true}
              value={question.answer || ""}
              onChange={(e) => onQuestionUpdate(e, question)}
            />
          </div>
        )
    }
  }

  render() {
    const {
      question: {type},
    } = this.props
    return (
      <div className="intake-survey-question-input">
        {this.renderMainInput()}
        {type !== "free" && type !== "free_text" ? this.renderRemarks() : null}
      </div>
    )
  }
}

export default withTranslation()(IntakeSurveyQuestionInput)
